import {post, downFile, postfile} from './http'
const baseUrl = '/api/admin/mktools'

// ================================= 签到活动管理相关接口 =================================
// 查询活动列表接口
export const getSignEventinfoList = v => post(`${baseUrl}/sign/getSignEventinfoList`, v.data, v.success, v.error)

// 修改活动状态接口
export const updateSignEventinfoStatus = v => post(`${baseUrl}/sign/updateSignEventinfoStatus`, v.data, v.success, v.error)

// 查询活动详情接口
export const getSignEventDetail = v => post(`${baseUrl}/sign/getSignEventDetail`, v.data, v.success, v.error)

// 查询签到信息列表
export const getSignEventRollList = v => post(`${baseUrl}/sign/getSignEventRollList`, v.data, v.success, v.error)

// 获取签到活动基本信息
export const getSignEventBasicInfo = v => post(`${baseUrl}/sign/getSignEventBasicInfo`, v.data, v.success, v.error)

// 查询名单详情
export const getSignEventRollDetail = v => post(`${baseUrl}/sign/getSignEventRollDetail`, v.data, v.success, v.error)

// 删除名单信息
export const deleteImportRollInfo = v => post(`${baseUrl}/sign/deleteImportRollInfo`, v.data, v.success, v.error)

// 查询签到导入名单列表
export const getSignEventImportList = v => post(`${baseUrl}/sign/getSignEventImportList`, v.data, v.success, v.error)
// 查询签到导入名单详情
export const getSignEventImportRollDetail = v => post(`${baseUrl}/sign/getSignEventImportRollDetail`, v.data, v.success, v.error)
// 签到导入名单导出excel
export const exportImportSignRollExcel = v => downFile(`${baseUrl}/sign/exportImportSignRollExcel`, v.data, v.success, v.error)

// 签到名单下载excel模板
export const exportSignExcelTemplate = v => downFile(`${baseUrl}/sign/exportSignExcelTemplate`, v.data, v.success, v.error)

// 签到名单导入
export const importSignRollExcel = v => postfile(`${baseUrl}/sign/importSignRollExcel`, v.data, v.success, v.error)

// 签到名单导出excel
export const exportSignRollExcel = v => downFile(`${baseUrl}/sign/exportSignRollExcel`, v.data, v.success, v.error)

// ================================= 互动活动管理相关接口 =================================
// 查询活动列表接口
export const getInteractEventinfoList = v => post(`${baseUrl}/interact/getInteractEventinfoList`, v.data, v.success, v.error)

// 修改活动状态接口
export const updateInteractEventinfoStatus = v => post(`${baseUrl}/interact/updateInteractEventinfoStatus`, v.data, v.success, v.error)

// 查询活动详情接口
export const getInteractEventDetail = v => post(`${baseUrl}/interact/getInteractEventDetail`, v.data, v.success, v.error)

// 查询互动名单列表
export const getInteractEventRollList = v => post(`${baseUrl}/interact/getInteractEventRollList`, v.data, v.success, v.error)

// 查询互动名单详情
export const getInteractEventRollDetail = v => post(`${baseUrl}/interact/getInteractEventRollDetail`, v.data, v.success, v.error)

// 互动名单导出excel
export const exportInteractRollExcel = v => downFile(`${baseUrl}/interact/exportInteractRollExcel`, v.data, v.success, v.error)

// ================================= 抽奖活动管理相关接口 =================================

// 抽奖活动名单导出excel
export const exportLuckdrawRollExcel = v => downFile(`${baseUrl}/luckdraw/exportLuckRollExcel`, v.data, v.success, v.error)

// 查询抽奖名单列表
export const getLuckdrawEventRollList = v => post(`${baseUrl}/luckdraw/getLuckEventRollList`, v.data, v.success, v.error)

// 查询抽奖活动详情接口
export const getLuckDrawEventDetail = v => post(`${baseUrl}/luckdraw/getLuckDrawEventDetail`, v.data, v.success, v.error)

// 查询抽奖活动列表接口
export const getLuckDrawEventinfoList = v => post(`${baseUrl}/luckdraw/getLuckDrawEventinfoList`, v.data, v.success, v.error)

// 查询抽奖名单详情
export const getLuckdrawEventRollDetail = v => post(`${baseUrl}/luckdraw/getLuckEventRollDetail`, v.data, v.success, v.error)

// 提交快递发货信息
export const updateLuckEventship = v => post(`${baseUrl}/luckdraw/updateLuckEventship`, v.data, v.success, v.error)

// 修改活动状态接口
export const updateLuckDrawEventStatus = v => post(`${baseUrl}/luckdraw/updateLuckDrawEventStatus`, v.data, v.success, v.error)

// 获取证书关联的媒资列表
export const getCertKMCInfoList = v => post('/api/admin/kmc/cert/getCertKMCInfoList', v.data, v.success, v.error)
// 删除证书
export const deleteCertInfo = v => post('/api/admin/kmc/cert/deleteCertInfo', v.data, v.success, v.error)
// 获取证书背景列表  新增使用
export const getCertBgList = v => post('/api/admin/kmc/cert/getCertBgList', v.data, v.success, v.error)
// 获取证书关联媒资的详情 新增使用
export const getCertKMCDetail = v => post('/api/admin/kmc/cert/getCertKMCDetail', v.data, v.success, v.error)
// 获取证书详情
export const getCertinfoDetail = v => post('/api/admin/kmc/cert/getCertinfoDetail', v.data, v.success, v.error)
// 获取证书列表
export const getCertinfoList = v => post('/api/admin/kmc/cert/getCertinfoList', v.data, v.success, v.error)
// 新增或编辑证书
export const saveOrUpdateCertinfo = v => post('/api/admin/kmc/cert/saveOrUpdateCertinfo', v.data, v.success, v.error)

// 限时折扣
export const getLimitList = v => post('/api/admin/kmc/limitdis/getLimitDisCountList', v.data, v.success, v.error)
export const getLimitView = v => post('/api/admin/kmc/limitdis/getLimitDisDetail', v.data, v.success, v.error)
export const getLimitKmcList = v => post('/api/admin/kmc/limitdis/getLimitKMCInfoList', v.data, v.success, v.error)
export const editLimit = v => post('/api/admin/kmc/limitdis/saveOrUpdateLimitDisinfo', v.data, v.success, v.error)
export const editLimitStatus = v => post('/api/admin/kmc/limitdis/updateLimitDisCountStatus', v.data, v.success, v.error)

// 问卷
export const getAllCommonFormList = v => post('/api/admin/kmc/commonform/getAllCommonFormList', v.data, v.success, v.error)
export const getCommonFormDetail = v => post('/api/admin/kmc/commonform/getCommonFormDetail', v.data, v.success, v.error)
export const getCommonUserFormList = v => post('/api/admin/kmc/commonform/getCommonUserFormList', v.data, v.success, v.error)
export const saveOrUpdateCommonForm = v => post('/api/admin/kmc/commonform/saveOrUpdateCommonForm', v.data, v.success, v.error)
export const updateCommonStatus = v => post('/api/admin/kmc/commonform/updateCommonStatus', v.data, v.success, v.error)
export const getCommonformKMCList = v => post('/api/admin/kmc/commonform/getCommonformKMCList', v.data, v.success, v.error)
export const exportCommonUserFormList = v => downFile('/api/admin/kmc/commonform/exportCommonUserFormList', v.data, v.success, v.error)

// 兑换码
export const getAsseTredeemCodeList = v => post('/api/admin/kmc/code/getAsseTredeemCodeList', v.data, v.success, v.error)
export const getAsseCommonformKMCList = v => post('/api/admin/kmc/code/getCommonformKMCList', v.data, v.success, v.error)
export const cancelTredeemCodeInfo = v => post('/api/admin/kmc/code/cancelTredeemCodeInfo', v.data, v.success, v.error)
export const getAsseTredeemCodeInfo = v => post('/api/admin/kmc/code/getAsseTredeemCodeInfo', v.data, v.success, v.error)
export const uploadAsseTredeemCodeInfo = v => post('/api/admin/kmc/code/uploadAsseTredeemCodeInfo', v.data, v.success, v.error)
export const getAsseTredeemCodeDetailList = v => post('/api/admin/kmc/code/getAsseTredeemCodeDetailList', v.data, v.success, v.error)
export const getCustomerBalanceInfo = v => post('/api/admin/kmc/code/getCustomerBalanceInfo', v.data, v.success, v.error)
export const getCwCustomerInfoByMobileno = v => post('/api/admin/kmc/code/getCwCustomerInfoByMobileno', v.data, v.success, v.error)
export const sendTredeemCodeInfo = v => post('/api/admin/kmc/code/sendTredeemCodeInfo', v.data, v.success, v.error)
export const uploadTredeemCodeAddStockcount = v => post('/api/admin/kmc/code/uploadTredeemCodeAddStockcount', v.data, v.success, v.error)
export const uploadTredeemCodeByExstatus = v => post('/api/admin/kmc/code/uploadTredeemCodeByExstatus', v.data, v.success, v.error)
export const uploadTredeemCodeBySendstatus = v => post('/api/admin/kmc/code/uploadTredeemCodeBySendstatus', v.data, v.success, v.error)
export const exportAsseTredeemCodeDetailList = v => downFile('/api/admin/kmc/code/exportAsseTredeemCodeDetailList', v.data, v.success, v.error)
